import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";
import "./design-modern.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Could not find #root element");
}

import { restoreDesign } from "./shell/DesignToggle";
restoreDesign();

// Dev-only mock backend. The localStorage flag alone is a RUNTIME check, so
// without this compile-time guard the whole mock ships to production and
// anyone setting rp.mock=1 there gets a console full of invented data.
//
// The imports are DYNAMIC, inside the DEV branch. They were static, on the
// belief that the modules were side-effect-free and Rollup would drop them —
// but mock/install.ts mutates its fixture objects at module top level, so the
// bundler kept those statements and the invented tenants, agents and emails
// shipped to production (inert: nothing read them; spec 024 FR-008). With
// DEV folded to false the whole branch, imports included, is removed.
//
// installWebMocks patches ApiClient.prototype, so it must run before the
// first render: in dev the render waits for it.
function render(): void {
  createRoot(container!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

if (import.meta.env.DEV) {
  const [{ installWebMocks }, { mountMockPanel }] = await Promise.all([
    import("./mock/install"),
    import("./mock/MockPanel"),
  ]);
  installWebMocks();
  render();
  mountMockPanel();
} else {
  render();
}
